module.exports = __webpack_public_path__ + "static/media/about-glogowek.b01da928.mp4";